module.exports = __webpack_public_path__ + "img/IMG_7076.1940a77e.webp";